import axios from 'axios';
import config from './config';
import { useAppStore } from '@/stores/appstore';
import NProgress from 'nprogress';
import router from '@/customer/router';

NProgress.configure({ easing: 'ease', speed: 1500 });
// create a new axios instance
const instance = axios.create({
    baseURL: config.ApiUrl
});
// before a request is made start  nprogress
instance.interceptors.request.use(async options => {
    NProgress.start();
    const store = useAppStore();
    options.headers = { 'Authorization': `Bearer ${store.Token}`, 'Content-Type': 'application/json' };
    return options;
});

//Todo: Add check for token expiry
instance.interceptors.response.use(
    async response => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        NProgress.done();

        return response.data;
    },
    async error => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error      
        NProgress.done();
        if (error.response && error.response.status === 401) {
            const store = useAppStore();
            store.logOut();
            router.push({ name: 'Login' });
        }

        throw error.response ? error.response.data : error.message;
    }
);

export default instance;